import React from 'react';
import './Projetos.css';

function Projetos() {
  return (
    <section className="galeria-projetos">
    <h2 className="titulo-galeria">Galeria de Projetos Realizados</h2>
    <div className="container">
      <div className="projeto">
          <img src={require('../img/casa.jpg')} alt="Imagem da Casa" />
          <br></br>
          <h3>Residência Veraneio G&I  Ibiúna/SP</h3>
          <p>Em andamento</p>
      </div>
      <div className="projeto">
        <img src={require('../img/reforma.jpg')} alt="Imagem da Casa 2" />
        <h3>Reforma de Residência BN Sorocaba</h3>
        <p>Em andamento</p>
      </div>
      <div className="projeto">
        <img src={require('../img/ninho.jpg')} alt="Imagem da Casa 3" />
        <h3>Residência L&L Ninho Verde II  </h3>
        <p>Finalizada</p>
      </div>
      <div className="projeto">
        <img src={require('../img/11.jpg')} alt="Imagem da Casa 3" />
        <h3>Residência R&P Ibiúna/SP </h3>
        <p>Finalizada</p>
      </div>
    </div>
  </section>
  );
}
export default Projetos;